import ManualPage from './ManualPage'
import { adminManual } from './manualContent'

export default function AdminManualPage() {
  return <ManualPage content={adminManual} />
}
